import { OptionModel } from "../../common/types/OptionModel";

export const exchangeType: OptionModel[] = [
    {
        value: "DOV_ALIS",
        label: "DÖVİZ ALIŞ"
    },
    {
        value: "DOV_SATIS",
        label: "DÖVİZ SATIŞ"
    },
    {
        value: "EFF_ALIS",
        label: "EFEKTİF ALIŞ"
    },
    {
        value: "EFF_SATIS",
        label: "EFEKTİF SATIŞ"
    }
];